export default "__VITE_ASSET__de55e992__"